import { mapTaskCategoryFromDto } from '../tasks/helpers';
function mapSaleProductFromDto(dto, quantity) {
    var _a, _b;
    return {
        _dto: dto,
        id: dto.id,
        name: dto.name,
        quantity,
        price: dto.price,
        currency: dto.currencyCode,
        itemNumber: dto.productNumber,
        description: dto.description,
        thumbnail: dto.thumbnail,
        unit: dto.unit,
        maxOrderAmount: dto.maxOrderAmount,
        maxKvmSize: dto.maxKvmSize,
        // EFKT-MOCK — mocked false until BE returns showCopyrightAlert; see ISaleProductDto.showCopyrightAlert.
        showAlert: (_a = dto.showCopyrightAlert) !== null && _a !== void 0 ? _a : false,
        // EFKT-MOCK — see IProduct.tasks. Unknown dto category strings are dropped rather than
        // crashing the reverse lookup.
        tasks: ((_b = dto.tasks) !== null && _b !== void 0 ? _b : [])
            .map(({ type }) => mapTaskCategoryFromDto(type))
            .filter((type) => !!type)
            .map(type => ({ type })),
    };
}
export function mapBundledProductFromDto(dto) {
    return {
        ...mapSaleProductFromDto(dto, dto.quantity),
        isRequired: dto.isRequired,
    };
}
/** `GET /api/accounts/{accountId}/products/alacarte` row — the canonical `IProduct`, plus the two
 * fields (`config`/`variant`) the add-order-line write echoes straight back. */
export function mapAlacarteProductFromDto(dto) {
    return {
        ...mapSaleProductFromDto(dto, dto.quantity),
        config: dto.config,
        variant: dto.variant,
    };
}
/**
 * The group's own product comes first, then its members — that is the radio-button order the user
 * sees, and the first entry is the one whose selection maps to `memberId: null`.
 */
export function mapProductChoiceFromDto(dto) {
    const products = [mapSaleProductFromDto(dto, 1), ...dto.members.map(member => mapSaleProductFromDto(member, 1))];
    const prices = products.map(({ price }) => price).filter((price) => typeof price === 'number');
    return {
        substituteId: dto.id,
        group: dto.name,
        products,
        minPrice: prices.length ? Math.min(...prices) : undefined,
    };
}
/**
 * `grouping` is the value the read was filtered by, passed in rather than read off the row — CRM
 * applies the filter and the response carries no per-package grouping. See `IPackage.type`.
 */
export function mapPackageFromDto(dto, grouping) {
    return {
        _dto: dto,
        id: dto.id,
        type: grouping,
        name: dto.name,
        isBundle: dto.isBundle,
        totalPrice: dto.price,
        basePrice: dto.price,
        currency: dto.currencyCode,
        products: (dto.bundledProducts || []).map(mapBundledProductFromDto),
        choices: (dto.substitutiveProducts || []).map(mapProductChoiceFromDto),
        description: dto.description,
        thumbnail: dto.thumbnail, // EFKT-MOCK — see IPackage.thumbnail
    };
}
export function mapAddonGroupFromDto(dto) {
    return {
        categoryId: dto.categoryId,
        categoryName: dto.categoryName,
        products: dto.products.map(product => ({
            ...mapSaleProductFromDto(product, 0),
            categoryId: dto.categoryId,
            categoryName: dto.categoryName,
        })),
    };
}
export function mapSelectableFeeFromDto(dto) {
    return {
        id: dto.id,
        code: dto.code,
        name: dto.name,
        price: dto.price,
        currency: dto.currencyCode,
    };
}
/**
 * Efkt returns a bare code such as `DETACHED_HOUSE` with no translations, so there is nothing to
 * localise and the mapper needs no locale argument — unlike datahub's, which took one.
 */
export function mapPropertyTypeFromDto({ code, isEnabled }) {
    return {
        key: code,
        name: code,
        isEnabled,
    };
}
